"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

require("./index.css");

var classnames_1 = __importDefault(require("classnames"));

var react_1 = require("react");

var index_1 = require("../../index");

var CollapsibleGroup = function (_a) {
  var title = _a.title,
      secondaryTitle = _a.secondaryTitle,
      dataTestId = _a.dataTestId,
      className = _a.className,
      children = _a.children,
      rightPart = _a.rightPart,
      props = __rest(_a, ["title", "secondaryTitle", "dataTestId", "className", "children", "rightPart"]);

  var _b = (0, react_1.useState)(false),
      isOpen = _b[0],
      setOpen = _b[1];

  var collapse = function () {
    return setOpen(!isOpen);
  };

  var handleKeyPress = function (_a) {
    var code = _a.code;

    if (code === 'Space') {
      setOpen(!isOpen);
    }
  };

  return (0, jsx_runtime_1.jsxs)("div", __assign({
    "data-testid": dataTestId,
    className: (0, classnames_1.default)('collapsible-row', className)
  }, props, {
    children: [(0, jsx_runtime_1.jsxs)("div", __assign({
      className: "top-row"
    }, {
      children: [(0, jsx_runtime_1.jsx)("div", __assign({
        className: "icon-wrapper",
        onClick: collapse,
        onKeyPress: handleKeyPress,
        tabIndex: 0,
        role: "button",
        "data-testid": "collapse-button"
      }, {
        children: (0, jsx_runtime_1.jsx)(index_1.Icon, {
          name: isOpen ? 'desc' : 'down-chevron',
          width: "24"
        }, void 0)
      }), void 0), (0, jsx_runtime_1.jsx)("div", __assign({
        className: "title"
      }, {
        children: title
      }), void 0), (0, jsx_runtime_1.jsx)("div", __assign({
        className: "secondary-title"
      }, {
        children: secondaryTitle
      }), void 0), rightPart && (0, jsx_runtime_1.jsx)("div", __assign({
        className: "right-part"
      }, {
        children: rightPart
      }), void 0)]
    }), void 0), isOpen && (0, jsx_runtime_1.jsx)("div", __assign({
      className: "content"
    }, {
      children: children
    }), void 0)]
  }), void 0);
};

exports.default = CollapsibleGroup;